import './DetailsMobileHeader.scss';

import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { openDrawer } from "../../../slices/drawerSlice";

import Update from "@mui/icons-material/Update";

import { LargeTitle } from "../../../common-components/Titles/Titles";
import { TextButton } from "../../../common-components/Buttons/Buttons";
import { Button } from "../../../common-components/Buttons/Buttons";

import DeparturesReportUpdate from "../../../departures/components/DeparturesReportUpdate/DeparturesReportUpdate";
import DeparturesReportUpdateFooter from "../../../departures/components/DeparturesReportUpdate/components/DeparturesReportUpdateFooter/DeparturesReportUpdateFooter";

const DetailsMobileHeader = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const data = useSelector((state) => state.user.data);
    const permissions = data?.relationships?.role?.permissions || [];

    const hasPermission = permissions.some(
        (permission) => permission.name === "branch_update_create"
    );

    const handleOpen = () => {
        dispatch(openDrawer({content: <DeparturesReportUpdate/>, footer: <DeparturesReportUpdateFooter id={id}/>}));
    }
    
    const handleNavigate = () => {
        navigate('/Departures');
    }

    return (
        <div className={"details-mobile-header"}>
            <div className={"details-mobile-header_container"}>
                <div className={"details-mobile-header_link"}>
                    <TextButton title={"Назад"} active={true} onClick={handleNavigate}/>
                </div>
                <div className={"details-mobile-header_title"}>
                    <LargeTitle property={"Детальная информация"}/>
                </div>
                {hasPermission && (
                    <div className={"details-mobile-header_button"}>
                        <Button Icon={Update} title={"Обновить"} onClick={handleOpen}/>
                    </div>
                )}
            </div>
        </div>
    )
}

export default DetailsMobileHeader;